import { SOCIAL_CARDS } from './socialCards'

const PORCELAIN_TIKTOK_CARD = SOCIAL_CARDS.find((card) => card.id === '7463181975772237098')

const CHUCKY_TIKTOK = {
  id: '7476533914023038250',
  poster: '/images/posters/sakira-chucky-fnaf-meet.jpg',
}

export const sakiraCaseStudy = {
  aboutTitle: 'About Sakira Mods',
  contentTitle: 'Sakira Mods Content',
  about:
    'Sakira Mods is an original IP co-created with the creator of FNMeka. Sakira was created to bridge the gap between Men and Women car creators. Our goal was to create a female character that could prove women can design vehicles as good as men. During her run of around a year and a half we gained 400K+ followers and averaged around 1M+ views on each video across YouTube, TikTok, and Instagram.',
  aboutMedia: [
    {
      id: 'about-doomslayer-lambo',
      label: "Doomslayer's Lambo",
      video: '/videos/sakira-doomslayer-lambo.mp4',
      poster: '/images/posters/sakira-doomslayer-lambo.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 415000,
          likes: 46900,
          comments: 213,
          saves: 7500,
        },
        youtube: {
          views: 82000,
          comments: 12,
        },
        instagram: {
          views: 567000,
          likes: 50000,
          comments: 280,
        },
      },
    },
    {
      id: 'about-koi-porsche',
      label: 'Koi Porsche',
      video: '/videos/sakira-koi-porsche.mp4',
      poster: '/images/posters/sakira-koi-porsche.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 2000000,
          likes: 136600,
          comments: 1015,
          saves: 18500,
        },
        youtube: {
          views: 2600000,
          likes: 16000,
          comments: 49,
        },
        instagram: {
          views: 1700000,
          likes: 137000,
          comments: 746,
        },
      },
    },
    {
      id: 'about-mormon-rolls-royce',
      label: 'LDS Rolls-Royce',
      video: '/videos/sakira-mormon-rolls-royce.mp4',
      poster: '/images/posters/sakira-mormon-rolls-royce.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 1600000,
          likes: 60000,
          comments: 654,
          saves: 9212,
        },
        youtube: {
          views: 35000,
          likes: 438,
          comments: 15,
        },
        instagram: {
          removed: true,
        },
      },
    },
    {
      id: 'about-woody-buzz-drift',
      label: 'Woody & Buzz Drift',
      video: '/videos/sakira-woody-buzz-drift.mp4',
      poster: '/images/posters/sakira-woody-buzz-drift.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 1700000,
          likes: 179200,
          comments: 606,
          saves: 20600,
        },
        youtube: {
          views: 137000,
          likes: 1100,
          comments: 13,
        },
        instagram: {
          views: 1000000,
          likes: 109000,
          comments: 356,
        },
      },
    },
    {
      id: 'about-yao-ming-porsche',
      label: 'Yao Ming Porsche',
      video: '/videos/sakira-yao-ming-porsche.mp4',
      poster: '/images/posters/sakira-yao-ming-porsche.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 25200000,
          likes: 2800000,
          comments: 20600,
          saves: 446200,
        },
        youtube: {
          views: 1400000,
          likes: 24000,
          comments: 556,
        },
        instagram: {
          views: 23400000,
          likes: 2400000,
          comments: 10500,
        },
      },
    },
    {
      id: 'about-bmw-knight-battle',
      label: 'BMW Knight Battle',
      video: '/videos/sakira-bmw-knight-battle.mp4',
      poster: '/images/posters/sakira-bmw-knight-battle.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          removed: true,
        },
        instagram: {
          removed: true,
        },
        youtube: {
          views: 298000,
          likes: 2500,
          comments: 15,
        },
      },
    },
    {
      id: 'about-femslayer-lambo',
      label: 'FemSlayer Lambo',
      video: '/videos/sakira-femslayer-lambo.mp4',
      poster: '/images/posters/sakira-femslayer-lambo.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 1500000,
          likes: 204600,
          comments: 1721,
          saves: 34200,
        },
        instagram: {
          views: 1300000,
          likes: 151500,
          comments: 1067,
        },
        youtube: {
          views: 94000,
          likes: 1300,
          comments: 36,
        },
      },
    },
    {
      id: 'about-porcelain-supra',
      label: 'Chinese Porcelain Supra',
      video: '/videos/sakira-porcelain-supra.mp4',
      poster: '/images/posters/sakira-porcelain-supra.jpg',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 8400000,
          likes: 1100000,
          comments: 6948,
          saves: 115300,
        },
        youtube: {
          views: 352000,
          likes: 5100,
          comments: 72,
        },
        instagram: {
          views: 10800000,
          likes: 1100000,
          comments: 5095,
        },
      },
    },
    {
      id: 'about-chucky-fnaf-meet',
      label: 'ChuckyCheese FNAF Car Meet',
      isShort: true,
      socialStats: {
        tiktok: {
          views: 1100000,
          likes: 57500,
          comments: 803,
          saves: 10000,
        },
        youtube: {
          views: 497000,
          likes: 4700,
          comments: 57,
        },
        instagram: {
          views: 1200000,
          likes: 75300,
          comments: 517,
        },
      },
    },
  ],
  socialCards: SOCIAL_CARDS,
  process: [
    'Cinematics were produced on tight timelines, typically 1–2 weeks, which called for fast iteration, decisive creative direction, and efficient real-time workflows. As the only Unreal Engine cinematic artist, I prioritized what mattered most on screen to deliver high-quality results quickly.',
    'Idea → Storyboard & Dialogue → Rigging & Character Dev → Scene Building → Mocap → VCam Filming → VFX → Animation Cleanup → Lighting → Fix Visual Bugs/ Console Commands → Render',
  ],
  responsibilities: [
    'Full pipeline development. Scene assembly, rigging, lighting, animation, VFX, and final delivery.',
    'Storyboarding, script dialogue creation, and voice acting.',
    'Set up Vicon mocap system; directed and recorded actors, and performed roles myself.',
  ],
  sections: [
    {
      title: 'Rigging',
      blocks: [
        {
          title: 'Vehicle Rigging Workflow',
          body: [
            'Built a reusable vehicle rig in UE5. The base setup: steering, wheel rotation, wheel interaction with terrain and body tilt carries across cars. Then joints are added on based on the cars unique setup.',
          ],
          mediaLayout: 'carousel',
          media: [
            {
              id: 'rigging-vehicle-overview',
              label: 'Vehicle rigging overview',
              video: '/videos/sakira-vehicle-rigging-overview.mp4',
              poster: '/images/posters/sakira-vehicle-rigging-overview.jpg',
              isShort: false,
            },
            {
              id: 'rigging-jiggle-bones',
              label: 'Jiggle bone physics',
              video: '/videos/sakira-jiggle-bone-physics.mp4',
              poster: '/images/posters/sakira-jiggle-bone-physics.jpg',
              isShort: false,
            },
          ],
        },
        {
          title: 'Humanoid Rig Creation',
          body: [
            'Created auto-rigged characters, brought them into Unreal, and built Control Rigs I could reuse across the cast, adding custom blendshapes for expressions and moments the base rig couldn\'t handle.',
          ],
          bullets: [
            'Added cloth physics for secondary motion.',
            'Created flipbook materials for characters So i could animate there faces.',
          ],
          media: [
            {
              id: 'rigging-humanoid-overview',
              label: 'Character Rigs',
              video: '/videos/sakira-humanoid-rig-overview.mp4',
              isShort: false,
            },
          ],
        },
      ],
    },
    {
      title: 'Vicon Motion Capture & Animation',
      body: [
        'Captured, Acted and implemented performance in Vicon\'s Shogun Live. From mocap cleanup to character and spline driven vehicle animation.',
      ],
      blocks: [
        {
          title: 'Motion Capture Pipeline (Vicon to Unreal Engine)',
          body: [
            'I ran the full mocap pipeline. Calibrated the system, captured and acted in performances, retargeted main characters through MotionBuilder, and cleaned everything up in Unreal.',
          ],
          bullets: [
            'Captured motion using Vicon Shogun and processed data in Vicon Post.',
            'Cleaned up noise, jitter, and timing issues in the mocap data in Unreal Engine after baking animation in Level Sequencer.',
            'Adjusted performances for cinematic pacing and camera work.',
            'Handled non-humanoid characters with custom rigs and hand animation.',
          ],
          media: [
            {
              id: 'animation-mocap-pipeline',
              label: 'Motion capture Preview',
              video: '/videos/sakira-vicon-mocap-pipeline.mp4',
              isShort: false,
            },
          ],
        },
        {
          title: 'Spline-Based Vehicle & Object Animation',
          body: [
            'Used splines in Unreal to drive vehicle motion. Props and objects were animated with baked simulations through Take Recorder and/or hand animation.',
          ],
          bullets: [
            'Animated vehicles along splines for smooth, controllable motion, editing spline segmenting for smooth rendering.',
            'Hand animated characters and props to have weight emotion.',
          ],
          mediaLayout: 'carousel',
          media: [
            {
              id: 'animation-spline-vehicle',
              label: 'Spline Animation - Car',
              video: '/videos/sakira-spline-vehicle.mp4',
              poster: '/images/posters/sakira-spline-vehicle.jpg',
              isShort: false,
            },
            {
              id: 'cinematics-koi-animation',
              label: 'Koi Fish animation',
              video: '/videos/sakira-cinematics-koi-control-rig.mp4',
              poster: '/images/posters/sakira-cinematics-koi-control-rig.jpg',
              isShort: false,
            },
          ],
        },
      ],
    },
    {
      title: 'VCam Filming',
      body: [
        'Directed camera work using Unreal Engine’s Virtual Camera, then refined in Sequencer for final shot quality.',
        'With a small team, consisting of the Lead 3D modeler and I (and whoever we can hire), we recorded animation first and filmed after. I had to plan character placement in the scene upfront. We only filmed once timing of the animation and spacing of hero characters and props felt solid.',
      ],
      blocks: [
        {
          title: 'Camera Direction: Hybrid Workflow (VCam + Keyframed Cameras)',
          body: [
            'Recorded Virtual Camera passes and parented a new cine camera ontop for iteration control.',
          ],
          bullets: [
            'Directed camera movement and composition with Virtual Camera.',
            'Used VCam for natural, handheld-feeling camera motion.',
            'Left in small imperfections so the camera felt less robotic on social media platforms.',
            'Attached a Cine Camera to the VCam pass, then cleaned up the movement.',
          ],
          media: [
            {
              id: 'cinematics-vcam',
              label: 'VCam camera preview',
              video: '/videos/sakira-cinematics-vcam.mp4',
              isShort: false,
            },
          ],
        },
      ],
    },
    {
      title: 'Level Sequencing',
      body: [
        'Built cinematics with multiple sequences in a master Level Sequence. This allowed for easy organization and iteration.',
      ],
      blocks: [
        {
          title: 'Master Sequences & Shot Organization',
          body: [
            'Used Master Sequences to keep shots grouped and easy to view flow, pacing and energy.',
          ],
          bullets: [
            'Organized scenes into shots and sub-sequences.',
            'Built dedicated lighting subsequences for each Level Sequence, keeping lighting separate from animation for faster iteration.',
          ],
          media: [
            {
              id: 'sequencer-master-sequence',
              label: 'Master Sequence overview with labeled shots',
              video: '/videos/sakira-master-sequence-overview.mp4',
              isShort: false,
            },
          ],
        },
      ],
    },
    {
      title: 'Lighting, VFX & Post Processing',
      body: [
        'Lit and timed VFX per shot in Sequencer so effects stayed readable and matched the animation beats.',
      ],
      blocks: [
        {
          title: 'Shot-Driven Lighting & Emphasis',
          body: [
            'Drove lighting changes per shot in Sequencer for mood, readability, and focus. Also using Post Processing Volumes to enhance the visual storytelling.',
          ],
          bullets: [
            'Set lighting to support mood and focal points.',
            'Animated light intensity, color, and position per shot.',
            'Pushed attention to characters or story beats with light cues.',
            'Matched lighting changes to camera movement and animation.',
            'Created Materials for Post Process Volume. Including adding Dirt Mask and color grading.',
          ],
          media: [
            {
              id: 'cinematics-ppv-lighting',
              label: 'Koi Fish Postprocess Effects for Backroom Vibe',
              video: '/videos/sakira-cinematics-ppv-lighting.mp4',
              isShort: false,
            },
          ],
        },
        {
          title: 'VFX Timing & Shot Integration',
          body: [
            'Triggered and tuned VFX inside Sequencer so effects supported the shot instead of fighting it.',
          ],
          bullets: [
            'Timed VFX beats to animation and camera movement by editing parameters or changing the Niagara system for more control.',
            'Adjusted effect intensity and duration per shot through Niagara parameters in Level Sequencer and created new parameters for specific needs.',
            'Kept effects performant and readable in real time.',
            'Fixed VFX visibility issues with Path Tracer and continuity breaks between scenes by reusing baked simulation, console commands or editing project settings.',
          ],
          media: [
            {
              id: 'sequencer-vfx-timing',
              label: 'VFX timing',
              video: '/videos/sakira-vfx-timing.mp4',
              isShort: false,
            },
          ],
        },
      ],
    },
    {
      title: 'Rendering',
      body: [
        'Finished and exported cinematics in Unreal with Path Tracer, formatted for YouTube, TikTok, and Instagram.',
      ],
      blocks: [
        {
          title: 'Path Tracer Output',
          body: [
            'Handled final polish and output in Unreal using Path Tracer.',
          ],
          bullets: [
            'Finished sequencing, polish, and export in Path Tracer.',
            'Balanced render quality with tight timelines.',
            'Delivered final cuts formatted for YouTube, TikTok, and Instagram.',
            'Matched path-traced output to the real-time viewport with console variables and unique solutions for effects that are not allowed in Path tracer.',
          ],
        },
      ],
    },
    {
      title: 'Compositing',
      body: [
        'Built a lightweight compositing workflow inside Unreal for simple shots. The process was built through render layers, Post process effect and tagging assets in Blueprints to isolate or remove characters/props.',
      ],
      blocks: [
        {
          bullets: [
            'Compositing setup was limited to shots that did not require masking.',
          ],
          mediaLayout: 'carousel',
          showSocialStats: true,
          media: [
            {
              id: 'compositing-unreal-2',
              label: 'Compositing in Unreal, Sample',
              video: '/videos/sakira-compositing-in-unreal-2.mp4',
              poster: '/images/posters/sakira-compositing-in-unreal-2.jpg',
              isShort: true,
            },
            {
              id: 'compositing-unreal-engine-3',
              label: 'Compositing in Unreal Engine, ChuckyCheese',
              tiktokId: CHUCKY_TIKTOK.id,
              poster: CHUCKY_TIKTOK.poster,
              isShort: true,
            },
            {
              id: 'compositing-porcelain-supra',
              label: 'Chinese Porcelain Supra, final result',
              tiktokId: PORCELAIN_TIKTOK_CARD?.id || '7463181975772237098',
              poster: PORCELAIN_TIKTOK_CARD?.thumbnail,
              isShort: true,
            },
          ],
        },
        {
          title: 'Composite Process',
          bullets: [
            'Used tracked camera data from After Effects and Cinema 4D.',
            'Imported image sequences onto image plates.',
            'Matched on-set lighting with HDRI maps from free sources.',
            'Built a render-layer system for multi-pass output.',
            'Tagged assets in Blueprints so characters and meshes could be separated cleanly.',
            'Added post-process effects such as ambient occlusion, shadow, and alpha maps as render layers.',
          ],
          media: [
            {
              id: 'compositing-plate-process',
              label: 'Compositing in Unreal Engine',
              video: '/videos/sakira-compositing-process.mp4',
              isShort: false,
            },
          ],
        },
      ],
    },
  ],
}
